import Vue from 'vue'
import VueInsProgressBar from 'vue-ins-progress-bar'
import PaymentRequestPopover from '@/components/custom/PaymentRequestPopover.vue'

Vue.component('PaymentRequestPopover', PaymentRequestPopover)

Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '5px'
})
